module.exports = __webpack_public_path__ + "static/media/p3_4.2e9d6085.png";